// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper_lDZ7i {
  width: 100%;
  border: 1px solid var(--ececf1-border);
  border-radius: 10px;
  display: flex;
  background: var(--white-background);
  box-sizing: border-box;
  margin-top: 10px;
  &.open_E7b_y {
    > .leftContainer_ol3CV {
      min-width: 10px;
      background-color: var(--_10a37f-background) !important;
    }
  }
}

.leftContainer_ol3CV {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  border-radius: 10px 0 0 10px;
  -webkit-border-radius: 10px 0 0 10px;
  -moz-border-radius: 10px 0 0 10px;
  -ms-border-radius: 10px 0 0 10px;
  -o-border-radius: 10px 0 0 10px;
}
.rightContainer_qACLC {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 12px 15px;
  gap: 10px;
  position: relative;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/CustomAutomationsWrapper/CustomAutomationsWrapper.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,sBAAsB;EACtB,gBAAgB;EAChB;IACE;MACE,eAAe;MACf,sDAAsD;IACxD;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;EACjC,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;AACxB","sourcesContent":[".wrapper {\n  width: 100%;\n  border: 1px solid var(--ececf1-border);\n  border-radius: 10px;\n  display: flex;\n  background: var(--white-background);\n  box-sizing: border-box;\n  margin-top: 10px;\n  &.open {\n    > .leftContainer {\n      min-width: 10px;\n      background-color: var(--_10a37f-background) !important;\n    }\n  }\n}\n\n.leftContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  border-radius: 10px 0 0 10px;\n  -webkit-border-radius: 10px 0 0 10px;\n  -moz-border-radius: 10px 0 0 10px;\n  -ms-border-radius: 10px 0 0 10px;\n  -o-border-radius: 10px 0 0 10px;\n}\n.rightContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  padding: 12px 15px;\n  gap: 10px;\n  position: relative;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper_lDZ7i`,
	"open": `open_E7b_y`,
	"leftContainer": `leftContainer_ol3CV`,
	"rightContainer": `rightContainer_qACLC`
};
export default ___CSS_LOADER_EXPORT___;
